import * as Sentry from '@sentry/react'

import { isScenarioActive } from './scenario'
import { readScenario } from './store/scenarioStore'

export async function initMocktail(): Promise<void> {
  const scenario = readScenario()
  if (!isScenarioActive(scenario)) return

  try {
    const { startMocktailWorker } = await import('./engine/mocktailWorker')
    await startMocktailWorker()
  } catch (error) {
    Sentry.captureException(error)
  }
}
